<circ-person [showLogin]="showLogin" [showImage]="showImage" [person]="person | async" [showName]="showName" [fontSize]="fontSize"></circ-person>
